import PageHeader from '../../components/common/PageHeader';
import styles from './AdvancedReport.module.css';

function AdvancedReport() {
  return (
    <div>
      <PageHeader title="Advanced Report" subtitle="In-depth analytics and custom reports" />
      <div className={styles.placeholder}>
        <div className={styles.placeholderIcon}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10" />
            <line x1="12" y1="20" x2="12" y2="4" />
            <line x1="6"  y1="20" x2="6"  y2="14" />
          </svg>
        </div>
        <h3>Advanced reporting coming soon</h3>
        <p>Custom date ranges, exportable reports, profit &amp; loss breakdowns, and trend comparisons are being built here.</p>
      </div>
    </div>
  );
}

export default AdvancedReport;
